import api from "./api";

export const getStatisticsPlants = async () => {
    const response = await api.get(`plants/generalData`);
    return response.data;
};